import { useContext, useState } from 'react'

import { useMasterDeleteApi } from '@/common/api/modules/master'
import { masterTypeName } from '@/common/app/modules/master'
import { useShowDeletedToast } from '@/common/app/toast'
import { MasterType } from '@/common/model/master/w2Master'

import IconButton from '@/components/view/atoms/button/IconButton'
import DisclosureRow from '@/components/view/atoms/disclosure/DisclosureRow'
import { IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import { DisclosurePositionVertical } from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

import { ConfirmDialogContext } from '@/components/container/modal/dialog/confirm/ConfirmDialogProvider'

interface Props {
  siteId: number
  masterType: MasterType
  selectedIds: number[]
  reload: () => void
}

const MasterListBulkOperationButton = ({ siteId, masterType, selectedIds, reload }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)

  const showDelete = useShowDeletedToast()
  const { trigger: deleteSelected } = useMasterDeleteApi({
    onSuccess: () => {
      reload()
      showDelete(`選択した${masterTypeName(masterType)}`)
    }
  })
  const { showModal: showConfirm, hide: hideConfirm } = useContext(ConfirmDialogContext)

  return (
    <DisclosureWrapper
      off={!showing}
      vertical={DisclosurePositionVertical.TOP}
      disclosureNode={
        <>
          <DisclosureRow
            onClick={() => {
              showConfirm({
                message: '選択したマスタを一括削除しますか？',
                noText: 'キャンセル',
                yesText: '削除する',
                onClickYes: async () => {
                  for (const id of selectedIds) {
                    await deleteSelected({
                      master_type: masterType,
                      site_id: siteId,
                      record_id: id
                    })
                  }

                  hideConfirm()
                }
              })
            }}
          >
            <Text lineHeight={150}>{masterTypeName(masterType)}を一括削除</Text>
          </DisclosureRow>
        </>
      }
      onClickOutSide={() => setShowing(false)}
    >
      <IconButton type={IconType.OTHER} color='emphasis' onClick={() => setShowing(true)} />
    </DisclosureWrapper>
  )
}

export default MasterListBulkOperationButton
